export const groupsRequestList_actionType = {
    GROUPS_REQUEST_LIST_START: "GROUPS_REQUEST_LIST_START",
    GROUPS_REQUEST_LIST_SUCCESS: "GROUPS_REQUEST_LIST_SUCCESS",
    GROUPS_REQUEST_LIST_ERROR: "GROUPS_REQUEST_LIST_ERROR",
    GROUPS_REQUEST_LIST_RESET: "GROUPS_REQUEST_RESET"
};